import React from "react"


export const Footer = () => {

    return (
        <div className='footer-menu'>
            <ul>
                <li>Da Morning Grind @2024</li>
                <li>damorningrind@gmail.com</li>
                <li>1003 Pensacola Street, Honolulu, HI 96814</li>
            </ul>
        </div>
    )
}